import { history } from 'store';

import { setTrackingContext, clearTrackingContext } from './context';
import { installLifecycleHandlers, flush } from './queue';
import { trackPv } from './track';
import { EUserType } from 'services/BackendApi';

const PV_PATHS = ['/search', '/booking-builder', '/pure-ai'];
const shouldTrackPv = (pathname: string) => PV_PATHS.some(p => pathname.startsWith(p));

let initialized = false;


export const initTrackingEvents = (identity: {
  email: string;
  country?: string | null;
  userType: EUserType;
}): void => {
  setTrackingContext(identity);

  if (initialized) return;
  initialized = true;

  installLifecycleHandlers();

  if (shouldTrackPv(window.location.pathname)) {
    trackPv();
  }

  history.listen(() => {
    if (shouldTrackPv(window.location.pathname)) {
      trackPv();
    }
  });
};

export const resetTrackingEvents = (): void => {
  flush();
  clearTrackingContext();
};
